import React from 'react';

function PostAdSectionOne({ 
  formData, 
  handleChange, 
  handleRemoveImage, 
  handleSetCoverImage,
  getLocalizedText,
  accommodationTypes, // New prop
  tenantsOptions, // New prop
  priceDurations, // New prop
  hostTypeOptions, // New prop
  isFieldValid
}) {
  return (

    <div className="section-group">
      {/* Host Type */}
      <div className="filter-section">
        <h3>
          {getLocalizedText('نوع المُعلن', 'What type of host are you?')}
          <span className={`required-indicator ${isFieldValid('host_type') ? 'valid-check' : 'required-star'}`}>
            {isFieldValid('host_type') ? '✓' : '*'}
          </span>
        </h3>
        <div className="filter-options-group filter-options-group--grid">
          {hostTypeOptions.map(option => (
            <div className="filter-option" key={option.value}>
              <input
                type="radio"
                id={`host_type_${option.value}`}
                name="host_type"
                value={option.value}
                checked={formData.host_type === option.value}
                onChange={handleChange}
              />
              <label htmlFor={`host_type_${option.value}`}>{getLocalizedText(option.ar, option.en)}</label>
            </div>
          ))}
        </div>

        {formData.host_type === 'manager' && (
          <div className="form-group host-manager-value">
            <label htmlFor="hostManagerValue">
              {getLocalizedText(
                'ما هي الخدمة التي تقدمها للضيف كمدير للوحدة؟',
                'What is the service you provide for the guest as a unit manager?'
              )}
              <span className={`required-indicator ${isFieldValid('host_manager_value') ? 'valid-check' : 'required-star'}`}>
                {isFieldValid('host_manager_value') ? '✓' : '*'}
              </span>
            </label>
            <textarea
              id="hostManagerValue"
              name="host_manager_value"
              value={formData.host_manager_value}
              onChange={handleChange}
              placeholder={getLocalizedText(
                'اشرح للضيف الخدمة أو القيمة المضافة التي ستقدمها كمدير للوحدة',
                'Explain to the guest the service or added value you provide as a unit manager'
              )}
              minLength="75"
              maxLength="1500"
            ></textarea>
            <div className="description-hint">
              {getLocalizedText(
                'اقل حد 75 حرف - اكثر حد 1500 حرف',
                'Minimum 75 characters - Maximum 1500 characters'
              )}
            </div>
          </div>
        )}
      </div>

      {/* Accommodation Type */}
      <div className="filter-section">
        <h3>
          {getLocalizedText('نوع الإقامة', 'Accommodation Type')}
          <span className={`required-indicator ${isFieldValid('accommodation_type') ? 'valid-check' : 'required-star'}`}>
    {isFieldValid('accommodation_type') ? '✓' : '*'}
  </span>
          </h3>
        <div className="filter-options-group filter-options-group--grid">
          {accommodationTypes.map(option => ( // Refactored: Dynamic map
            <div className="filter-option" key={option.value}>
              <input
                type="radio"
                id={option.value}
                name="accommodation_type"
                value={option.value}
                checked={formData.accommodation_type === option.value}
                onChange={handleChange}
              />
              <label htmlFor={option.value}>{getLocalizedText(option.ar, option.en)}</label>
            </div>
          ))}
        </div>
      </div>

      {/* Accommodation Images */}
      <div className="filter-section">
        <div className="image-section-header">
          <h3>
            {getLocalizedText('صور الإقامة', 'Accommodation Images')}
            <span className="image-upload-note">{getLocalizedText('يرجى رفع ٤ صور على الأقل بجودة عالية', 'At least upload 4 images with high quality')}</span>
          </h3>
          <div className="image-upload-container">
            <div className="image-upload-row">
              {[...Array(5)].map((_, index) => (
                <div key={index} className="image-upload-slot">
                  {index === 0 ? (
                    <>
                      <input
                        type="file"
                        id="adImages"
                        name="ad_images"
                        multiple
                        accept="image/*"
                        onChange={handleChange}
                        style={{ display: 'none' }}
                      />
                      <label htmlFor="adImages" className="image-upload-button">
                        +
                      </label>
                    </>
                  ) : (
                    !formData.ad_images[index - 1] ? (
                      <div className="image-placeholder">
                        <span className="camera-icon">📷</span>
                      </div>
                    ) : (
                      <div className={`image-preview-container${index - 1 === 0 ? ' image-preview-container--cover' : ''}`}>
                        {index - 1 === 0 && (
                          <span className="cover-tab">
                            {getLocalizedText('الغلاف', 'Cover')}
                          </span>
                        )}
                        <img
                          src={URL.createObjectURL(formData.ad_images[index - 1])}
                          alt={`Preview ${index}`}
                          className="image-preview"
                        />
                        {index - 1 !== 0 && (
                          <button
                            type="button"
                            className="set-cover-button"
                            onClick={() => handleSetCoverImage(index - 1)}
                          >
                            {getLocalizedText('اجعلها الغلاف', 'Set Cover')}
                          </button>
                        )}
                        <button
                          type="button"
                          className="image-delete-button"
                          onClick={() => handleRemoveImage(index - 1)}
                        >
                          ×
                        </button>
                      </div>
                    )
                  )}
                </div>
              ))}
            </div>
            <div className="image-upload-row">
              {[...Array(5)].map((_, index) => (
                <div key={index + 5} className="image-upload-slot">
                  {!formData.ad_images[index + 4] ? (
                    <div className="image-placeholder">
                      <span className="camera-icon">📷</span>
                    </div>
                  ) : (
                    <div className="image-preview-container">
                      <img
                        src={URL.createObjectURL(formData.ad_images[index + 4])}
                        alt={`Preview ${index + 5}`}
                        className="image-preview"
                      />
                      <button
                        type="button"
                        className="set-cover-button"
                        onClick={() => handleSetCoverImage(index + 4)}
                      >
                        {getLocalizedText('اجعلها الغلاف', 'Set Cover')}
                      </button>
                      <button
                        type="button"
                        className="image-delete-button"
                        onClick={() => handleRemoveImage(index + 4)}
                      >
                        ×
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="form-note">
              {getLocalizedText(
                'نشر صور واضحة للمكان و هو مرتب يزيد فرص ظهور إعلانك لأكبر عدد من المستخدمين.',
                'Posting clear photos when the place is organised increases the chances of your Ad reaching more users.'
              )}
            </div>
          </div>
        </div>
      </div>

{/* Tenants - Conditional Rendering */}
{formData.accommodation_type !== 'studio' && (
  <div className="filter-section">
    <h3>
      {getLocalizedText('نوع المستأجرين', 'Tenants Gender')}
      <span className={`required-indicator ${isFieldValid('tenants_policy') ? 'valid-check' : 'required-star'}`}>
        {isFieldValid('tenants_policy') ? '✓' : '*'}
      </span>
    </h3>
    <div className="filter-options-group">
      {tenantsOptions.map(option => (
        <div className="filter-option" key={option.value}>
          <input
            type="radio"
            id={`tenants_${option.value}`}
            name="tenants_policy"
            value={option.value}
            checked={formData.tenants_policy === option.value}
            onChange={handleChange}
          />
          <label htmlFor={`tenants_${option.value}`}>{getLocalizedText(option.ar, option.en)}</label>
        </div>
      ))}
    </div>
  </div>
)}
      
      {/* Description */}
      <div className="form-group">
        <label htmlFor="adDescription">
          {getLocalizedText('وصف السكن', 'Accommodation Description')}
          <span className={`required-indicator ${isFieldValid('ad_description') ? 'valid-check' : 'required-star'}`}>
            {isFieldValid('ad_description') ? '✓' : '*'}
          </span>
        </label>
        <textarea
          id="adDescription"
          name="ad_description"
          value={formData.ad_description}
          onChange={handleChange}
          placeholder={getLocalizedText('صف السكن الذي تقدمه', 'Describe the accommodation you\'re offering')}
          minLength="75"
          maxLength="1500"
        ></textarea>
        <div className="description-hint">
          {getLocalizedText(
            'اقل حد 75 حرف - اكثر حد 1500 حرف',
            'Minimum 75 characters - Maximum 1500 characters'
          )}
        </div>
      </div>
      <div className="section-divider"></div>
    </div>
  );
}

export default PostAdSectionOne;